import { useNavigate } from 'react-router';
import { signOut } from '../lib/firebase';

export function NoAccess() {
  const nav = useNavigate();
  async function onBack() {
    await signOut();
    nav('/');
  }
  return (
    <div className="h-screen flex items-center justify-center px-6 text-center">
      <div className="max-w-[480px]">
        <h1 className="text-xl font-semibold mb-3">Acceso denegado</h1>
        <p className="text-text-secondary mb-6">
          Usuario no reconocido, ponte en contacto con el administrador.
        </p>
        <button type="button" className="btn btn-secondary" onClick={onBack}>
          Volver al inicio
        </button>
      </div>
    </div>
  );
}
